import { fork } from 'redux-saga/effects';

import clearSuggestedActionsOnPostActivitySaga from '/druid/sagas/clearSuggestedActionsOnPostActivitySaga';
import connectionStatusToNotificationSaga from '/druid/sagas/connectionStatusToNotificationSaga';
import connectionStatusUpdateSaga from '/druid/sagas/connectionStatusUpdateSaga';
import connectSaga from '/druid/sagas/connectSaga';
import detectSlowConnectionSaga from '/druid/sagas/detectSlowConnectionSaga';
import emitTypingIndicatorToPostActivitySaga from '/druid/sagas/emitTypingIndicatorToPostActivitySaga';
import markAllAsSpokenOnStopSpeakActivitySaga from '/druid/sagas/markAllAsSpokenOnStopSpeakActivitySaga';
import observeActivitySaga from '/druid/sagas/observeActivitySaga';
import postActivitySaga from '/druid/sagas/postActivitySaga';
import queueIncomingActivitySaga from '/druid/sagas/queueIncomingActivitySaga';
import sendEventToPostActivitySaga from '/druid/sagas/sendEventToPostActivitySaga';
import sendFilesToPostActivitySaga from '/druid/sagas/sendFilesToPostActivitySaga';
import sendMessageBackToPostActivitySaga from '/druid/sagas/sendMessageBackToPostActivitySaga';
import sendMessageToPostActivitySaga from '/druid/sagas/sendMessageToPostActivitySaga';
import sendPostBackToPostActivitySaga from '/druid/sagas/sendPostBackToPostActivitySaga';
import sendTypingIndicatorOnSetSendBoxSaga from '/druid/sagas/sendTypingIndicatorOnSetSendBoxSaga';
import speakActivityAndStartDictateOnIncomingActivityFromOthersSaga from '/druid/sagas/speakActivityAndStartDictateOnIncomingActivityFromOthersSaga';
import startDictateOnSpeakCompleteSaga from '/druid/sagas/startDictateOnSpeakCompleteSaga';
import startSpeakActivityOnPostActivitySaga from '/druid/sagas/startSpeakActivityOnPostActivitySaga';
import stopDictateOnCardActionSaga from '/druid/sagas/stopDictateOnCardActionSaga';
import stopSpeakingActivityOnInputSaga from '/druid/sagas/stopSpeakingActivityOnInputSaga';
import submitSendBoxSaga from '/druid/sagas/submitSendBoxSaga';

import type { GlobalScopePonyfill } from '/druid/types/GlobalScopePonyfill';
import type { Saga } from 'redux-saga';

type CreateSagasOptions = {
  ponyfill: GlobalScopePonyfill;
};

export default function createSagas({ ponyfill }: CreateSagasOptions): Saga {
  return function* () {
    // TODO: [P2] Since fork() silently catches all exceptions, we need to find a way to console.error them out.

    yield fork(clearSuggestedActionsOnPostActivitySaga);
    yield fork(connectionStatusToNotificationSaga);
    yield fork(connectionStatusUpdateSaga);
    yield fork(connectSaga);
    yield fork(detectSlowConnectionSaga, ponyfill);
    yield fork(emitTypingIndicatorToPostActivitySaga);
    yield fork(markAllAsSpokenOnStopSpeakActivitySaga);
    yield fork(observeActivitySaga);
    yield fork(postActivitySaga, ponyfill);
    yield fork(queueIncomingActivitySaga, ponyfill);
    yield fork(sendEventToPostActivitySaga);
    yield fork(sendFilesToPostActivitySaga);
    yield fork(sendMessageBackToPostActivitySaga);
    yield fork(sendMessageToPostActivitySaga);
    yield fork(sendPostBackToPostActivitySaga);
    yield fork(sendTypingIndicatorOnSetSendBoxSaga, ponyfill);
    yield fork(speakActivityAndStartDictateOnIncomingActivityFromOthersSaga);
    yield fork(startDictateOnSpeakCompleteSaga);
    yield fork(startSpeakActivityOnPostActivitySaga);
    yield fork(stopDictateOnCardActionSaga);
    yield fork(stopSpeakingActivityOnInputSaga);
    yield fork(submitSendBoxSaga);
  };
}
